import { createIcon } from '@chakra-ui/react';

export const InvoiceIcon = createIcon({
  displayName: 'InvoiceIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip0_2378_48240)">
          <path
            d="M11.375 2.04297L10.5 1.16797L9.625 2.04297L8.75 1.16797L7.875 2.04297L7 1.16797L6.125 2.04297L5.25 1.16797L4.375 2.04297L3.5 1.16797V9.33464H1.75V11.0846C1.75 12.053 2.53167 12.8346 3.5 12.8346H10.5C11.4683 12.8346 12.25 12.053 12.25 11.0846V1.16797L11.375 2.04297ZM11.0833 11.0846C11.0833 11.4055 10.8208 11.668 10.5 11.668C10.1792 11.668 9.91667 11.4055 9.91667 11.0846V9.33464H4.66667V2.91797H11.0833V11.0846Z"
            fill="#6E6789"
          />
          <path d="M8.75 4.08594H5.25V5.2526H8.75V4.08594Z" fill="#6E6789" />
          <path d="M10.5007 4.08594H9.33398V5.2526H10.5007V4.08594Z" fill="#6E6789" />
          <path d="M8.75 5.83594H5.25V7.0026H8.75V5.83594Z" fill="#6E6789" />
          <path d="M10.5007 5.83594H9.33398V7.0026H10.5007V5.83594Z" fill="#6E6789" />
        </g>
        <defs>
          <clipPath id="clip0_2378_48240">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
